import { ListRequestExtendReducer } from "../reducer/CompanyListRequestExtendReducer";

export const reducer = ListRequestExtendReducer;